import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-c-chica-solicitud-fondo-rendir",
  templateUrl: "./c-chica-solicitud-fondo-rendir.component.html",
  styleUrls: ["./c-chica-solicitud-fondo-rendir.component.scss"],
})
export class CChicaSolicitudFondoRendirComponent implements OnInit {
  constructor() {}

  optionsTipoMov: Array<any> = [];

  ngOnInit() {
    this.optionsTipoMov = [
      { value: "1", label: "Tipo Movimiento 1" },
      { value: "2", label: "Tipo Movimiento 2" },
      { value: "3", label: "Tipo Movimiento 3" },
    ];
  }
}
